import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import useObjectUrl from "@core-ui/hooks/useObjectUrl";
import useChatStore from "@ext/agent/components/store/ChatStore";
import { fetchStoredAttachment } from "@ext/agent/components/utils/fetchStoredAttachment";
import type { ChatAttachment } from "@ext/agent/core/attachmentStore";
import { useEffect, useState } from "react";

export const useStoredAttachmentSrc = (attachment: ChatAttachment) => {
	const sessionId = useChatStore((s) => s.activeSessionId);
	const apiUrlCreator = ApiUrlCreatorService.value;
	const { url: src, setBlob } = useObjectUrl();
	const [blob, setLoadedBlob] = useState<Blob | null>(null);
	const [failed, setFailed] = useState(false);
	const { storagePath, mime } = attachment;

	useEffect(() => {
		if (!sessionId) return undefined;
		let cancelled = false;
		const load = async () => {
			const loaded = await fetchStoredAttachment(apiUrlCreator, sessionId, { storagePath, mime });
			if (cancelled) return;
			if (!loaded) return setFailed(true);
			setBlob(loaded);
			setLoadedBlob(loaded);
		};
		load().catch(() => {
			if (!cancelled) setFailed(true);
		});
		return () => {
			cancelled = true;
		};
	}, [sessionId, storagePath, mime, setBlob]);

	return { src, blob, failed };
};
